import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { IAppConfig } from '../_foundation/models/configuration.models';
import {DateTime} from 'luxon';

@Injectable()
export class AppConfig {
  static settings: IAppConfig;

  constructor(private handler: HttpBackend) {
  }

  // settings are kept in config.json, so that we can change them in octopus deploy, after the app is built
  public load(): Promise<void> {
    const jsonFile = environment.config;
    const configUrl = `${jsonFile}${jsonFile.includes('?') ? '&' : '?'}v=${Date.now()}`;
    const headers = new HttpHeaders({
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0'
    });

    return new Promise<void>((resolve, reject) => {
      const httpClient = new HttpClient(this.handler);
      httpClient
        .get<IAppConfig>(configUrl, { headers })
        .toPromise()
        .then((response: IAppConfig) => {
          AppConfig.settings = response;
          AppConfig.settings.isVesselEnvironment = AppConfig.settings.environmentName.toLowerCase().includes('vessel');
          AppConfig.settings.isImplementerEnvironment = AppConfig.settings.environmentName.toLowerCase().includes('implementer');
          AppConfig.settings.isSandboxEnvironment = AppConfig.settings.environmentName.toLowerCase().includes('sandbox');
          AppConfig.settings.navbarColour = AppConfig.settings.isSandboxEnvironment
            ? 'sandbox-primary'
            : AppConfig.settings.isImplementerEnvironment
              ? 'imp-primary'
              : 'primary';

          this.handleJackingV2DateTimeParse(response);
          resolve(null);
        })
        .catch((response: any) => {
          reject(`Unable to load file ${jsonFile}: ${JSON.stringify(response)}`);
        });
    });
  }

  // ---- JACKING V2 CUTOVER DATE ----
  private handleJackingV2DateTimeParse(response: IAppConfig) {
    const fallback = DateTime.fromISO('1970-01-01T00:00:00Z', { zone: 'utc' });

    const raw = response.jackingV2StartDateUtc;

    if (raw instanceof DateTime) {
      // already converted
      AppConfig.settings.jackingV2StartDateUtc = raw;
    } else if (typeof raw === 'string' && (raw as string).trim()) {
      const dt = DateTime.fromISO(raw, { zone: 'utc' });

      if (!dt.isValid) {
        throw new Error(`Invalid jackingV2StartDateUtc: ${raw}`);
      }

      AppConfig.settings.jackingV2StartDateUtc = dt;
    } else {
      // if empty we can assume the vessel doesn't need it, so just set v2 start date far in past
      AppConfig.settings.jackingV2StartDateUtc = fallback;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts